import { Placemark } from '@pbe/react-yandex-maps'
import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import { FC } from 'react'
import { useNavigate } from 'react-router'
import { useAppSelector } from 'store/hooks'

import { TPoint } from '../types'
import { MarkIconType, MarkIconTypeHref } from '../types/MarkIconType'

import { PlacemarkWrapper } from './PlacemarkWrapper'

// метки на карте (для отображения серверных центров)
export const ServiceMarksObjects: FC = () => {
  const { serviceMarks } = useAppSelector(yandexMap)
  const navigate = useNavigate()

  const handleClick = (id: string) => {
    navigate(`/servicecenters/${id}`)
  }

  if (!serviceMarks) return <></>
  return (
    <>
      {serviceMarks.map((point: TPoint) => (
        <PlacemarkWrapper
          key={`${point.coordinates}`}
          geometry={point.coordinates as [number, number]}
        >
          <Placemark
            geometry={point.coordinates}
            properties={{
              hintContent: point.name,
            }}
            options={{
              iconLayout: 'default#image',
              iconImageHref: MarkIconTypeHref[MarkIconType.blueShop],
              iconImageSize: [46, 63],
            }}
            onClick={() => handleClick(point.uuid)}
          />
        </PlacemarkWrapper>
      ))}
    </>
  )
}
